var map = {
	"./apiKey.js": "35a9",
	"./auth.js": "c7d4",
	"./customer.js": "f1b1",
	"./fundTransfer.js": "81f5",
	"./organisation.js": "5315",
	"./virtualAccount.js": "db73",
	"./wallet.js": "dce2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e1";